/**
 * useSiteConfig · v2.6.9 batch BQ
 * ================================
 * Public CMS config for the marketing site (Home, About, Services, etc.).
 * Cached in module scope so navigating between marketing pages doesn't
 * cause a flash-of-default-content on each route change.
 */
import { useEffect, useState } from "react";
import api from "@/lib/api";

let _cache = null;
let _inflight = null;

export default function useSiteConfig() {
  const [cfg, setCfg] = useState(_cache);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    if (_cache) {
      setCfg(_cache);
      setLoading(false);
      return;
    }
    if (!_inflight) {
      _inflight = api.get("/site/config")
        .then((r) => { _cache = r.data; return r.data; })
        .catch(() => null)
        .finally(() => { _inflight = null; });
    }
    let cancelled = false;
    _inflight.then((data) => { if (!cancelled) { setCfg(data); setLoading(false); } });
    return () => { cancelled = true; };
  }, []);

  return { cfg, loading };
}

/** Force a refresh — used by the admin CMS after saving changes. */
export function invalidateSiteConfig() { _cache = null; }
